(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/receipt/receipt.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/receipt/receipt.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _React2 = React,
  Fragment = _React2.Fragment;
const Button = svs.ui.ReactButton;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS,
  HEADER = _svs$ticket_partner$s.HEADER,
  DIGITAL_RECEIPT = _svs$ticket_partner$s.DIGITAL_RECEIPT,
  PHYSICAL_RECEIPT = _svs$ticket_partner$s.PHYSICAL_RECEIPT,
  BUTTON_LABEL = _svs$ticket_partner$s.BUTTON_LABEL,
  ORDERED_PRODUCTS = _svs$ticket_partner$s.ORDERED_PRODUCTS;
const _svs$ticket_partner$s2 = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS.DIGITAL,
  MY_ORDERS_TEXT = _svs$ticket_partner$s2.MY_ORDERS_TEXT,
  MY_ORDERS_LINK_TEXT = _svs$ticket_partner$s2.MY_ORDERS_LINK_TEXT,
  PASSWORD_SENT = _svs$ticket_partner$s2.PASSWORD_SENT;
const INFO = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS.PHYSICAL.INFO;
const _svs$ticket_partner$c = svs.ticket_partner.constants.routes,
  MY_ORDERS = _svs$ticket_partner$c.MY_ORDERS,
  DIGITAL_TICKETS = _svs$ticket_partner$c.DIGITAL_TICKETS,
  PHYSICAL_TICKETS = _svs$ticket_partner$c.PHYSICAL_TICKETS;
const Link = svs.app.ReactRouter.Link;
const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableRow = _svs$ui$reactTable.TableRow,
  TableBody = _svs$ui$reactTable.TableBody,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableHead = _svs$ui$reactTable.TableHead,
  TableCell = _svs$ui$reactTable.TableCell;
const _svs$ticket_partner$c2 = svs.ticket_partner.constants.copy.TICKETS_TABLE,
  NAME = _svs$ticket_partner$c2.NAME,
  PRICE = _svs$ticket_partner$c2.PRICE,
  COUNT = _svs$ticket_partner$c2.COUNT,
  TOTAL = _svs$ticket_partner$c2.TOTAL;
const Receipt = _ref => {
  let type = _ref.type,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? null : _ref$email,
    _ref$isLoggedIn = _ref.isLoggedIn,
    isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
    _ref$articles = _ref.articles,
    articles = _ref$articles === void 0 ? [] : _ref$articles;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    articlesData = _useState2[0],
    setArticlesData = _useState2[1];
  useEffect(() => {
    const articlesCount = articles && Object.keys(articles).reduce((acc, key) => acc + parseInt(articles[key].count, 10), 0);
    if (articlesCount > 0) {
      setArticlesData(Object.values(articles));
    }
  }, []);
  const isDigital = type === DIGITAL_RECEIPT;
  const isPhysical = type === PHYSICAL_RECEIPT;
  const buttonLink = "/foretag-triss".concat(isDigital ? DIGITAL_TICKETS : PHYSICAL_TICKETS);
  const MyOrdersLink = () => React.createElement(Fragment, null, MY_ORDERS_TEXT, React.createElement(Link, {
    to: MY_ORDERS
  }, MY_ORDERS_LINK_TEXT));
  return React.createElement(Fragment, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h1", null, HEADER), React.createElement("p", null, ORDERED_PRODUCTS), React.createElement(Table, {
    large: true,
    striped: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, NAME), React.createElement(TableHeader, null, PRICE), React.createElement(TableHeader, null, COUNT), React.createElement(TableHeader, null, TOTAL))), React.createElement(TableBody, null, articlesData.filter(article => article.count > 0).map(article => React.createElement(TableRow, {
    key: article.name
  }, React.createElement(TableCell, null, article.name), React.createElement(TableCell, null, article.price, " SEK"), React.createElement(TableCell, null, article.count), React.createElement(TableCell, null, article.price * article.count))))), isDigital && React.createElement(Fragment, null, React.createElement("div", null, email && React.createElement("p", null, "En bekr\xE4ftelse p\xE5 best\xE4llningen skickas inom kort till angiven E-postadress (".concat(email, ")"))), React.createElement("div", null, isLoggedIn ? React.createElement(MyOrdersLink, null) : PASSWORD_SENT)), isPhysical && React.createElement(Fragment, null, React.createElement("p", null, INFO)))), isLoggedIn && React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    md: 6,
    sm: 12
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(Button, {
    href: buttonLink,
    transparent: true
  }, BUTTON_LABEL)))));
};
svs.ticket_partner.sharedComponents.receipt.Receipt = Receipt;

 })(window);